const { getAccessToken } = window.gdiHost;
const { noticeCodes: { INACTIVE_SIGNOUT }, } = window.modMyPages;
const timestampInSeconds = () => Math.floor(Date.now() / 1000);
const halfTimeOfExpiryDate = (expiresInSeconds) => (expiresInSeconds - timestampInSeconds()) / 2;
const toMs = (seconds) => Math.floor(seconds * 1000);
const delayPromise = (delayInMs) => new Promise((resolve) => setTimeout(resolve, delayInMs));
const reloadPage = () => {
    const getQueryParams = (url) => new URL(url).searchParams;
    const withQueryParams = (queryParams) => (params) => {
        Object.entries(queryParams).forEach(([key, value]) => {
            params.set(key, value);
        });
        return params;
    };
    const toQueryString = (params) => `?${params.toString()}`;
    window.location.href = [
        `${window.location.protocol}//`,
        window.location.host,
        window.location.pathname,
        toQueryString(withQueryParams({ notice: INACTIVE_SIGNOUT })(getQueryParams(window.location.href))),
    ].join('');
};
const tryReloadPageRecursively = (delayInMs = 0) => delayPromise(delayInMs)
    .then(getAccessToken)
    .then(({ expires }) => timestampInSeconds() >= expires
    ? reloadPage()
    : tryReloadPageRecursively(toMs(halfTimeOfExpiryDate(expires))));
export const reloadPageWhenTokenExpires = (expires) => {
    [expires]
        .filter((exp) => exp > 0)
        .map((exp) => toMs(halfTimeOfExpiryDate(exp)))
        .forEach(tryReloadPageRecursively);
};
export default reloadPageWhenTokenExpires;
